import { shortUserFromDto } from '@src/features/users/lib/user';

import type {
  HistoryClientContact,
  HistoryClientContactDto,
  HistoryContactOption,
  HistoryContactOptionDto,
  HistoryEntity,
  HistoryEntityDto,
  HistoryItem,
  HistoryItemDto,
  HistoryItemPayload,
} from '../types';

function historyEntityFromDto(entity: HistoryEntityDto): HistoryEntity {
  return {
    id: entity.id,
    name: entity.name,
    businessSegment: entity.business_segment,
  };
}

function historyClientContactFromDto(
  contact: HistoryClientContactDto,
): HistoryClientContact {
  return {
    id: contact.id,
    tenureId: contact.tenure,
    name: contact.name,
    portrait: contact.portrait,
  };
}

export function historyItemFromDto(item: HistoryItemDto): HistoryItem {
  return {
    id: item.id,
    date: item.date,
    typeId: item.type,
    entity: historyEntityFromDto(item.entity),
    clientContact: historyClientContactFromDto(item.client_contact),
    kellerContact: shortUserFromDto(item.keller_contact),
    description: item.description,
    notes: item.notes,
    canEdit: item.can_edit,
  };
}

export function historyContactOptionFromDto(
  option: HistoryContactOptionDto,
): HistoryContactOption {
  return {
    ...historyClientContactFromDto(option),
    client: historyEntityFromDto(option.client),
    current: option.current,
  };
}

/** The changed fields of an entry, or all of a new one, as the API takes them. */
export function historyItemPayloadToDto(payload: Partial<HistoryItemPayload>) {
  return {
    ...(payload.date !== undefined ? { date: payload.date } : {}),
    ...(payload.typeId !== undefined ? { type: payload.typeId } : {}),
    ...(payload.tenureId !== undefined ? { tenure: payload.tenureId } : {}),
    ...(payload.userId !== undefined ? { user: payload.userId } : {}),
    ...(payload.description !== undefined
      ? { description: payload.description }
      : {}),
    ...(payload.notes !== undefined ? { notes: payload.notes } : {}),
  };
}
